import { render, staticRenderFns } from "./ProjectInformationComponent.vue?vue&type=template&id=0ba92079&scoped=true"
import script from "./ProjectInformationComponent.vue?vue&type=script&lang=js"
export * from "./ProjectInformationComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectInformationComponent.vue?vue&type=style&index=0&id=0ba92079&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba92079",
  null
  
)

export default component.exports